import { useState } from "react";
import "../styles/Filters.css";
import Input from "./input";

const MonthFilterDropdown = ({
  filterName = "monthFilter",
  searchFilters,
  setSearchFilters,
  closeFilter,
  alignRight = false,
  setWrapperRef,
}) => {
  const currentValue = searchFilters?.[filterName]?.value || "";
  const [selected, setSelected] = useState(currentValue);

  const handleApply = () => {
    if (!selected || !selected.trim()) {
      setSearchFilters((prev = {}) => {
        const updated = { ...prev };
        delete updated[filterName];
        return updated;
      });
      if (closeFilter) closeFilter();
      return;
    }

    setSearchFilters((prev = {}) => {
      const updated = { ...prev };
      // Clear date range filter — mutually exclusive
      delete updated.dateRangeFilter;
      updated[filterName] = { filter_type: "month", value: selected.trim() };
      return updated;
    });

    if (closeFilter) closeFilter();
  };

  return (
    <div
      className={`filter_wrapper${alignRight ? " filter_wrapper_align_right" : ""}`}
      ref={setWrapperRef}
    >
      <div className="d-flex flex-column gap-2">
        <Input
          label="Month"
          type="month"
          name="monthFilter"
          value={selected}
          onChange={(e) => setSelected(e.target.value)}
        />
      </div>

      <div className="filter_buttons mt-3">
        <button type="button" onClick={closeFilter} className="btn-cancel">
          Cancel
        </button>
        <button
          type="button"
          onClick={handleApply}
          className="btn-apply"
          disabled={!selected}
          style={{ opacity: !selected ? 0.5 : 1, cursor: !selected ? "not-allowed" : "pointer" }}
        >
          Apply
        </button>
      </div>
    </div>
  );
};

export default MonthFilterDropdown;
